export const INITIAL_PAGE = 0;
export const SELLER_PAGINATION_SIZE = 20;
export const CUSTOMER_PAGINATION_SIZE = 20;
export const REPRESENTATIVE_PAGINATION_SIZE = 20;
export const REFERENCE_PAGINATION_SIZE = 20;
export const OFFICIAL_STORE_PAGINATION_SIZE = 20;
export const GOAL_PAGINATION_SIZE = 20;

